export interface CategoryItem {
  id: string
  label: string
}

export const defaultCategories: CategoryItem[] = [
  { id: '_Asylum', label: 'Asylum' },
  { id: '_AOS', label: 'AOS' },
  { id: '_EAD', label: 'EAD' },
  { id: '_H1B', label: 'H1B' },
  { id: '_K1', label: 'K1' },
]
